import { gql } from '@apollo/client';

export const GET_ROLE_DETAIL_BY_ID = gql`
  query GetRoleDetailById($id: Long!) {
    getRoleDetailById(id: $id) {
      success
      message
      data {
        id
        name
        description
        packageIds
        createdAt
        updatedAt
      }
    }
  }
`;

export interface GetRoleDetailByIdResponse {
  getRoleDetailById: {
    success: boolean;
    message: string;
    data?: {
      id?: number | string;
      name?: string;
      description?: string | null;
      packageIds?: number[];
      createdAt?: number | null;
      updatedAt?: number | null;
    } | null;
  };
}

export interface GetRoleDetailByIdVariables {
  id: number;
}
